const KEY = 'udv-mpr3d-session-v1'

export function loadMpr3dSession() {
  try {
    const raw = window.localStorage.getItem(KEY)
    if (!raw) return null
    const o = JSON.parse(raw)
    if (!o || typeof o !== 'object') return null
    return o
  } catch (e) {
    return null
  }
}

export function saveMpr3dSession(partial) {
  try {
    const prev = loadMpr3dSession() || {}
    const next = { ...prev, ...partial, t: Date.now() }
    window.localStorage.setItem(KEY, JSON.stringify(next))
    return next
  } catch (e) {
    return null
  }
}
